export default __webpack_public_path__ + "static/transak-4a147d787b4c30e1b774275e15de04d2.svg";